// TODO: use https://www.npmjs.com/package/uuid when switching to new enviroment.

export function v4() {
	const hash = () =>
		Math.floor((1 + Math.random()) * 0x10000)
			.toString(16)
			.substring(1);

	return `${hash()}${hash()}-${hash()}-${hash()}-${hash()}-${hash()}${hash()}${hash()}`;
}
